<!-- src/components/About.vue -->
<template>
  <div class="cover-container d-flex h-100 p-3 mx-auto flex-column">
    <header class="masthead mb-auto">
      <nav>
        <ul>
          <li><RouterLink to="/">Home</RouterLink></li>
        </ul>
      </nav>
      <nav>
        <h3>Gurdwara Guru Har Rai - West Bromwich</h3>
        <ul>
          <li>
            <RouterLink
              :to="{
                name: 'EntranceEnglish',
                query: { asthaan: 'guru-har-rai-sahib-west-bromwich' }
              }"
            >
              Entrance English
            </RouterLink>
          </li>
          <li>
            <RouterLink
              :to="{
                name: 'EntrancePunjabi',
                query: { asthaan: 'guru-har-rai-sahib-west-bromwich' }
              }"
              >Entrance Punjabi</RouterLink
            >
          </li>
        </ul>
      </nav>
      <nav>
        <h3>Singh Sabha - Somerset Road</h3>
        <ul>
          <li>
            <RouterLink
              :to="{
                name: 'EntranceEnglish',
                query: { asthaan: 'singh-sabha-somerset-road' }
              }"
              >Entrance English</RouterLink
            >
          </li>
          <li>
            <RouterLink
              :to="{
                name: 'EntrancePunjabi',
                query: { asthaan: 'singh-sabha-somerset-road' }
              }"
              >Entrance Punjabi</RouterLink
            >
          </li>
        </ul>
      </nav>
      <nav>
        <h3>Guru Nanak Darbaar - Uplands Road, Smethwick</h3>
        <ul>
          <li>
            <RouterLink
              :to="{
                name: 'EntranceEnglish',
                query: { asthaan: 'guru-nanak-darbar-uplands-road-smethwick' }
              }"
              >Entrance English</RouterLink
            >
          </li>
          <li>
            <RouterLink
              :to="{
                name: 'EntrancePunjabi',
                query: { asthaan: 'guru-nanak-darbar-uplands-road-smethwick' }
              }"
              >Entrance Punjabi</RouterLink
            >
          </li>
        </ul>
      </nav>
    </header>
  </div>
  <div>
      <span class="last-updated-footer">v{{ version }}</span>
  </div>
</template>

<script>
import packageJson from "../../package.json";

export default {
  name: "HomePage",
  data() {
    return {
      version: packageJson.version || "1.0", // Fallback to "1.0" if version is not available
      // Add your data properties here
    };
  },
  methods: {
    // Add your methods here
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
